// Browser Translation Utility
// This utility helps trigger browser translation features without language packs

export const triggerBrowserTranslation = (targetLanguage) => {
  // Method 1: Use translate attribute
  const translateAttribute = targetLanguage === 'English' ? 'no' : 'yes';
  document.documentElement.setAttribute('translate', translateAttribute);
  
  // Method 2: Use data attributes for better browser recognition
  if (targetLanguage !== 'English') {
    document.documentElement.setAttribute('data-translate', 'yes');
    document.documentElement.setAttribute('data-lang-target', targetLanguage);
  } else {
    document.documentElement.removeAttribute('data-translate');
    document.documentElement.removeAttribute('data-lang-target');
  }
  
  // Method 3: Trigger browser translation by changing content language
  const currentLang = document.documentElement.lang;
  const newLang = targetLanguage === 'English' ? 'en' : 
                  targetLanguage === '繁體' ? 'zh-Hant' : 'zh-Hans';
  
  if (currentLang !== newLang) {
    document.documentElement.lang = newLang;
    
    // Force browser to re-evaluate translation
    setTimeout(() => {
      // Add a temporary class to trigger re-render
      document.documentElement.classList.add('translation-trigger');
      setTimeout(() => {
        document.documentElement.classList.remove('translation-trigger');
      }, 100);
    }, 50);
  }
  
  // Method 4: Use meta tags for better translation detection
  let metaTranslate = document.querySelector('meta[name="google"]');
  if (!metaTranslate) {
    metaTranslate = document.createElement('meta');
    metaTranslate.name = 'google';
    document.head.appendChild(metaTranslate);
  }
  
  if (targetLanguage !== 'English') {
    metaTranslate.content = 'notranslate';
    // Remove notranslate after a short delay to allow translation
    setTimeout(() => {
      metaTranslate.content = '';
    }, 200);
  } else {
    metaTranslate.content = 'notranslate';
  }
};

export const setupTranslationHints = () => {
  // Add translation hints to important elements
  const translationElements = document.querySelectorAll('h1, h2, h3, p, span, div');
  
  translationElements.forEach(element => {
    // Skip elements that should not be translated (like math content)
    if (element.classList.contains('math-content') || 
        element.classList.contains('MathJax') ||
        element.querySelector('.MathJax')) {
      element.setAttribute('translate', 'no');
      return;
    }
    
    // Add translation hints for text content
    if (element.textContent && element.textContent.trim().length > 0) {
      element.setAttribute('translate', 'yes');
    }
  });
};

export const clearTranslationHints = () => {
  // Remove translation hints when switching to English
  const elements = document.querySelectorAll('[translate="yes"]');
  elements.forEach(element => {
    element.removeAttribute('translate');
  });
}; 